<template>
  <div >
    <a-card :title="title" class="wrap-list-right" :style="{ width: `${width}px`, height: `${height}px` }" v-if="defaultItems && defaultItems.length > 0">
      <a-input-search placeholder="请输入" enter-button @search="onSearch" v-model="inputSearch" />
      <virtual-list
        style="overflow-y: auto; margin-top: 5px"
        :data-key="'id'"
        :style="{ height: `${height-140}px` }"
        :data-sources="items"
        :extra-props="{ currentIndex, name }"
        :data-component="itemComponent"
        :item-class="'list-item-keep'"
        :keep="10"
        :estimate-size="60"
      />
    </a-card>
    <a-card v-else class="wrap-list-right" :style="{ width: `${width}px`, height: `${height}px` }">
      <a-empty>
        <span slot="description">{{ emptyDescript }} </span>
      </a-empty>
    </a-card>
  </div>
</template>

<script>
import item from './item'
import VirtualList from 'vue-virtual-scroll-list'

export default {
  props: {
    width: {
      type: Number,
      default: 500,
    },
    height: {
      type: Number,
      default: 500,
    },

    emptyDescript: {
      type: String,
      default: '暂无数据',
    },
    name: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => {
        return []
      },
    },
    currentIndex: {
      type: Number,
      default: 0
    }
  },
  name: 'LeftSider',
  data() {
    return {
      itemComponent: item,
      inputSearch: '',
      items: [],
      defaultItems: [],
    }
  },
  watch: {
    list: {
      handler(val) {
        this.defaultItems = val
        this.items = val
      },
      immediate: true,
    },
  },
  created() {
    this.$on('onClick', (value, index) => {
      this.$emit('fetchValue', value, index)
    })
  },
  methods: {
    async initData() {

      //   const params = this.params
      //   const rz = await this.$http.get(this.url, { params })
      //   将首个数据扔出去，true代表首个
    },
    onSearch() {
      this.items = this.defaultItems.filter((item) => item[this.key].includes(this.inputSearch))
      this.$emit('fetchValue', this.items[0])
    },
  },
  components: { VirtualList },
}
</script>
<style lang="stylus" scoped>
.wrap-list-right {
  // width: 400px;
  border: 1px solid #edeaea;
  border-radius: 10px;
  height: 100%;

  .list-item-keep {
    display: flex;
    align-items: center;
    padding: 0 1em;
    height: 60px;
    border-bottom: 1px solid;
    border-color: lightgray;
  }
}
</style>
